import React, {useState} from 'react';
import Modal from 'react-modal';
import {uid} from 'uid';
import {parseImport} from '../../import';
import {saveNewCharacter} from '../../characterRepository';
import {vtmT} from '../../i18n';
import '../../../styles/vtm/roll.css';

/** Reprise de personnages existants : le MJ colle un JSON, les personnages sont créés à son nom. */
const VtmImportModal = ({isOpen, onClose, campaignUid, dmUid}) => {
  const [text, setText] = useState('');
  const [errors, setErrors] = useState([]);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);

  const close = () => {
    setText('');
    setErrors([]);
    setDone(null);
    onClose();
  };

  const submit = async () => {
    const result = parseImport(text, {idUser: dmUid, idCampaign: campaignUid, nextUid: () => uid()});
    setErrors(result.errors);
    setDone(null);
    if (result.errors.length) return;
    setBusy(true);
    try {
      await Promise.all(result.characters.map(saveNewCharacter));
      setText('');
      setDone(result.characters.length);
    } catch (e) {
      console.log(e);
      setErrors([e.message]);
    }
    setBusy(false);
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={close} className="vtmModal" overlayClassName="vtmModalOverlay" contentLabel={vtmT('importCharacters')}>
      <div className="vtmModalHeader">
        <h2 className="vtmModalTitle">{vtmT('importCharacters')}</h2>
      </div>
      <p className="vtmModalHint">{vtmT('importHint')}</p>
      <textarea
        className="vtmImportText"
        value={text}
        onChange={event => setText(event.target.value)}
        spellCheck={false}
        aria-label={vtmT('importCharacters')}
      />
      {errors.length > 0 && (
        <ul className="vtmImportErrors">
          {errors.map(message => <li key={message}>{message}</li>)}
        </ul>
      )}
      {done !== null && <p className="vtmImportDone">{vtmT('importDone', {value: done})}</p>}
      <div className="vtmModalActions">
        <button type="button" className="vtmButton primary" onClick={submit} disabled={busy || !text.trim()}>{vtmT('importAction')}</button>
        <button type="button" className="vtmButton ghost" onClick={close}>{vtmT('close')}</button>
      </div>
    </Modal>
  );
};

export default VtmImportModal;
